<template>
  <span
    class="label"
    :class="[`label--${variant}`, { 'label--sm': size === 'sm' }]"
  >
    <span v-if="showDot" class="label__dot" />
    <slot />
  </span>
</template>

<script>
  import { defineComponent } from 'vue';

  export default defineComponent({
    name: 'Label',
    props: {
      variant: {
        type: String,
        default: 'default',
        validator: (value) =>
          ['default', 'success', 'warning', 'danger', 'info', 'primary'].includes(value),
      },
      size: {
        type: String,
        default: 'default',
        validator: (value) => ['default', 'sm'].includes(value),
      },
      showDot: {
        type: Boolean,
        default: false,
      },
    },
  });
</script>

<style scoped lang="scss">
  .label {
    display: inline-flex;
    align-items: center;
    gap: 0.375rem;
    padding: 0.25rem 0.5rem;
    border-radius: 0.375rem;
    font-size: 0.75rem;
    font-weight: 500;
    white-space: nowrap;
    border: 1px solid;

    &--sm {
      padding: 2px 6px;
      font-size: 11px;
      gap: 0.25rem;
    }

    &__dot {
      width: 8px;
      height: 8px;
      border-radius: 50%;
      flex-shrink: 0;
    }

    &--default {
      background: var(--slate-100);
      color: var(--slate-700);
      border-color: var(--slate-300);

      .label__dot {
        background: var(--slate-500);
      }
    }

    &--primary {
      background: var(--blue-50);
      color: var(--blue-700);
      border-color: var(--blue-300);

      .label__dot {
        background: var(--blue-500);
      }
    }

    &--success {
      background: var(--green-50);
      color: var(--green-700);
      border-color: var(--green-300);

      .label__dot {
        background: var(--green-500);
      }
    }

    &--warning {
      background: var(--amber-50);
      color: var(--amber-700);
      border-color: var(--amber-300);

      .label__dot {
        background: var(--amber-500);
      }
    }

    &--danger {
      background: var(--red-50);
      color: var(--red-700);
      border-color: var(--red-400);

      .label__dot {
        background: var(--red-500);
      }
    }

    &--info {
      background: var(--blue-50);
      color: var(--blue-700);
      border-color: var(--blue-300);

      .label__dot {
        background: var(--blue-500);
      }
    }
  }
</style>
